import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class DeleteModel extends Component {
    delete = () => {
        this.props
            .delete(this.props.id)
            .then(res => {
                this.props.hideDelete();
            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/deleteModal.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Delete record
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-center model-html-container"
                        >
                            Are you sure you want to delete this record?
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.delete}
                        >
                            Delete
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideDelete}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
DeleteModel.contextType = AppContext;
export default DeleteModel;



// WEBPACK FOOTER //
// ./src/components/admin/jobCategories/DeleteModel.js